<template>
    <div class="col-lg-12">
        <p class="spacing_btm">Need help? Your sales representative is {{ data.sales_rep }} (<a :href="`mailto:${data.sales_email}`">{{ data.sales_email }}</a>)</p>
        <div class="alert alert-info">
            <p>Do you know that CDI builds the best isolation curb on the market?  We do!</p>
            <p><strong>One Piece</strong> construction; <strong>Weather Guard</strong> installed; and <strong>Easy Spring Adjustments</strong> in the field.  Order online with <strong>Instant Access</strong> to many drawings including <strong>Conforming/Seismic Stamped Drawings</strong>.  Contact your rep for more information.</p>
        </div>
        <router-link class="btn btn-primary" :to="`/quote`" @click.native="setView('override_new')">CREATE A QUOTE</router-link>
        <UnverifiedQuotes v-if="data.unverified && data.unverified.length" :unverified="data.unverified" />
        <RecentRecords :records="data.quotes" businessObject="Quotes" />
        <RecentRecords :records="data.orders" businessObject="Orders" />
    </div>
</template>

<script>
import helpers from "@/store/helpers";
import { store } from '@/store/BusinessObject.store';
import UnverifiedQuotes from "@/components/my/dashboards/panels/UnverifiedQuotes";
import RecentRecords from "@/components/my/dashboards/panels/RecentRecords";
import appStore from '@/store/App.store';

export default {
    name: 'DefaultDashboard',
    components: {
        RecentRecords,
        UnverifiedQuotes,
    },
    data() {
        return {
            data: {
                state: store.state,
                appState: appStore.state
            },
        }
    },
    methods: {
        getMyData: function() {
            store.api('dashboard/get_panels', '')
                .then(result => this.data = result);
        },
        setView: function(view) {
            store.state.currentView = view;
        },
    },
    computed: {
        showPwa: function () {
            // If the user already has launched our application as a PWA
            if (window.matchMedia('(display-mode: standalone)').matches) {
                return false;
            }
            // The reason we are limiting this to Chrome browsers for now is because of the limited implementation.
            return helpers.getUserBrowser() === 'Google Chrome or Chromium';
        }
    },
    created() {
        store.state.name = '';
        store.state.object.id = 0;
        this.getMyData();
    }
}
</script>

<style scoped>

</style>